export enum apiUrlSubAdmin {
    SUB_ADMIN = '/v1/sub-admin/',
}
